/// <reference path="../../../../typings/index.d.ts" />
module App.Common.Directives {
    'use strict';

    export class Capitalise implements angular.IDirective {
        
        public restrict = 'A';
        public require = '?ngModel';

        public link = (scope:angular.IScope, element:angular.IAugmentedJQuery, attrs:angular.IAttributes, ctrl:any)=>{
            
            var capitalize = (inputValue:string) => {
                if (inputValue == undefined) inputValue = '';
                var capitalized = inputValue.toUpperCase();
                if (capitalized !== inputValue) {
                    ctrl.$setViewValue(capitalized);
                    ctrl.$render();
                }
                return capitalized;
            }
            ctrl.$parsers.push(capitalize);
            capitalize(scope[attrs['ngModel']]);

        };

    }

    angular
        .module('app.common.directives')
        .directive('capitalise', () => { return new Capitalise(); });
}
